namespace GeniuzPOS.Purchase {
    export class PoPurInvoiceAppColumns {
        static columnsKey = 'Purchase.PoPurInvoiceApp';
    }
}
